"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    fi: {
        AuthLoadingView: {
            loading: 'Lataa...',
        },
    },
};
